export var AiReviewNotificationEvent;
(function (AiReviewNotificationEvent) {
    AiReviewNotificationEvent["NeedsReview"] = "needs_review";
    AiReviewNotificationEvent["Assigned"] = "assigned";
})(AiReviewNotificationEvent || (AiReviewNotificationEvent = {}));
export var AiReviewNotificationChannel;
(function (AiReviewNotificationChannel) {
    AiReviewNotificationChannel["Bell"] = "bell";
    AiReviewNotificationChannel["SlackChannel"] = "slack_channel";
    AiReviewNotificationChannel["SlackDm"] = "slack_dm";
})(AiReviewNotificationChannel || (AiReviewNotificationChannel = {}));
export var AiReviewNotificationStatus;
(function (AiReviewNotificationStatus) {
    AiReviewNotificationStatus["Sent"] = "sent";
    AiReviewNotificationStatus["Errored"] = "errored";
    AiReviewNotificationStatus["Clicked"] = "clicked";
    AiReviewNotificationStatus["Dismissed"] = "dismissed";
})(AiReviewNotificationStatus || (AiReviewNotificationStatus = {}));
//# sourceMappingURL=aiReviewNotification.js.map